import React, { useState } from 'react';
import { Form, Button, Card, Alert, Container } from 'react-bootstrap';
import { createPort } from './services/api';
import { useNavigate } from 'react-router-dom';

const PortCreate: React.FC = () => {
  const [name, setName] = useState('');
  const [location, setLocation] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      await createPort({ name, location });
      setSuccess(true);
      setTimeout(() => navigate('/ports'), 1200);
    } catch (err) {
      setError('Failed to create port');
    }
    setLoading(false);
  };

  return (
    <Container className="p-4 p-md-5" style={{ maxWidth: 500 }}>
      <Card className="shadow-lg mt-4">
        <Card.Body>
          <h2 className="mb-4">Create Location</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" value={name} onChange={e => setName(e.target.value)} required />
            </Form.Group>
            <Form.Group className="mb-3" controlId="location">
              <Form.Label>State</Form.Label>
              <Form.Control type="text" value={location} onChange={e => setLocation(e.target.value)} required />
            </Form.Group>
            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">Location created successfully!</Alert>}
            <div className="d-flex justify-content-between">
              <Button variant="secondary" onClick={() => navigate('/ports')} disabled={loading}>Back to List</Button>
              <Button variant="primary" type="submit" disabled={loading}>{loading ? 'Creating...' : 'Create Location'}</Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PortCreate; 